import ActionId from "@/action/ActionId"
import { applyService, logService } from "@/service"
import BaseResumeAction from "@/action/actions/BaseResumeAction"
import { isAnyPreapprovalCode } from "@/model/apply/ApplyResponseCode"
import router from "@/router"
import { getCalculatorCents } from "@/util/calculator"
import { applicationState, providerState } from "@/state"

class HFDResumeAction extends BaseResumeAction {

    constructor(providerKey) {
        super(ActionId.RESUME, providerKey)
    }

    isResumable(preauthResponse, applyResponse) {
        if (applyResponse) {
            if (applyResponse.pendingReasons?.length) return true
            logService.info("Not resuming because there is a full apply response.")
            return false
        }

        // currently, only pre-qualifications are resumable
        const anyPreApprovalCode = isAnyPreapprovalCode(preauthResponse?.responseCode)

        if (!anyPreApprovalCode) {
            logService.info("Not resuming because there is no preapproval code")
        }

        return anyPreApprovalCode
    }

    async handleNavigation(preauthResponse, applyResponse) {
        const paymentPlans = await getPaymentPlans(this.providerKey, preauthResponse)
        applicationState.selectedPaymentPlan = paymentPlans
            .find(plan => plan.providerPlanCode === applicationState.application.selectedOffer?.paymentPlanCode)

        applicationState.application.selectedOffer = null
        await router.replace({ path: `/providers/${this.providerKey}/resume/from-prequalified` })
    }
}

async function getPaymentPlans(providerKey, response) {
    let paymentPlansResponse = await applyService.getPaymentPlans(providerKey, {
        amountCents: getCalculatorCents(response?.approvedAmountCents, applicationState.application.purchaseAmountCents),
    })

    let paymentPlans = paymentPlansResponse.paymentPlans
    if (!paymentPlans || !paymentPlans.length) {
        paymentPlans = providerState.getPaymentPlans()
    }
    return paymentPlans
}
export default HFDResumeAction
